// extracted by mini-css-extract-plugin
module.exports = {"Member":"AboutUs_Member__TLOu7","Avatar":"AboutUs_Avatar__VUDFv"};